export const LONGDATETIME12 = 'D MMM YYYY h:mm a'
export const LONGDATE = 'D MMM YYYY'
export const YYYYMMDD = 'YYYY-MM-DD'
export const NOTECOLOR = '#fcfcc5'
export const SYSTEMIDENTITYID = `eu-west-1:11111111-9999-8888-2222-777777777777`
export const SUSSDASLENDERID = 'da557c4b-165d-4b4e-9016-14cb969bbd13'
export const SUSSDPORTALNAME = 'Sussd Account'

